// TelcoTrack — ACL příjmu (GoodsReceipt / stock/add)
//
// Neosobní → pouze role `sklad`.
// Osobní → kdokoli s warehouse API přístupem (včetně příjmu na users.warehouse_id).
// HTTP POST stock/add / goods-receipt dál vyžaduje warehouse edit (sklad) —
// terén Příjemku v UI nezakládá; sklad smí cílit i osobní sklady.

import {
  hasWarehouseApiAccessRole,
  hasWarehouseEditRole,
} from '../constants/roles.constants';
import {
  isPersonalWarehouse,
  resolveWarehouseUiGroup,
  type WarehouseUiGroup,
  type WarehouseUiGroupInput,
} from './warehouse-ui-group.util';
import type { WarehouseIssueActor } from './warehouse-issue-acl.util';

export const WAREHOUSE_RECEIPT_DENIED_ROLE_CS =
  'Příjem na neosobní sklad smí provádět pouze role Sklad.';

export const WAREHOUSE_RECEIPT_DENIED_PERSONAL_NO_ACCESS_CS =
  'Nemáte oprávnění k příjmu na osobní sklad.';

/** @deprecated Osobní cíl příjemky je povolen (sklad + ACL). */
export const WAREHOUSE_RECEIPT_DENIED_NOT_BRANCH_CS =
  'Příjemka na tento typ skladu není povolena pro vaši roli.';

export interface WarehouseReceiptAccessResult {
  allowed: boolean;
  reasonCs: string | null;
  warehouseGroup: WarehouseUiGroup;
}

/**
 * Příjem zásoby: neosobní = edit role; osobní = warehouse API přístup
 * (libovolný osobní sklad, nejen vlastní `actor.warehouseId`).
 */
export function evaluateWarehouseReceiptAccess(
  actor: WarehouseIssueActor,
  warehouse: WarehouseUiGroupInput & { id: string },
): WarehouseReceiptAccessResult {
  const warehouseGroup = resolveWarehouseUiGroup(warehouse);
  const roles = actor.roles ? [...actor.roles] : [];
  const personal = isPersonalWarehouse(warehouse);

  if (personal) {
    if (!hasWarehouseApiAccessRole(roles)) {
      return {
        allowed: false,
        reasonCs: WAREHOUSE_RECEIPT_DENIED_PERSONAL_NO_ACCESS_CS,
        warehouseGroup,
      };
    }
    return { allowed: true, reasonCs: null, warehouseGroup };
  }

  if (!hasWarehouseEditRole(roles)) {
    return {
      allowed: false,
      reasonCs: WAREHOUSE_RECEIPT_DENIED_ROLE_CS,
      warehouseGroup,
    };
  }

  return { allowed: true, reasonCs: null, warehouseGroup };
}

export function canReceiveStockToWarehouse(
  actor: WarehouseIssueActor,
  warehouse: WarehouseUiGroupInput & { id: string },
): boolean {
  return evaluateWarehouseReceiptAccess(actor, warehouse).allowed;
}
